import { render } from "./UploadItem.vue?vue&type=template&id=a04ae36e&scoped=true"
import script from "./UploadItem.vue?vue&type=script&lang=js"
export * from "./UploadItem.vue?vue&type=script&lang=js"

import "./UploadItem.vue?vue&type=style&index=0&id=a04ae36e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a04ae36e"]])

export default __exports__